import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type TJsonQuery } from '@/packages/JsonQuery';

import { type RequestStatus } from '@/microfrontends/filters/shared/types/RequestStatus';
import { type ISearchMeta } from '@/microfrontends/filters/shared/types/searchMeta';

import { JSON_QUERY_DEFAULT } from '../../constants/jsonQuery';
import { SEARCH_META_DEFAULT } from '../../constants/searchMeta';
import { applyFilters } from '../../thunks/applyFilters';

export interface IListingState {
  searchStatus: RequestStatus;
  jsonQuery: TJsonQuery;
  meta: ISearchMeta;
}

const listingInitialState: IListingState = {
  searchStatus: 'initial',
  jsonQuery: JSON_QUERY_DEFAULT,
  meta: SEARCH_META_DEFAULT,
};

export const listingSlice = createSlice({
  initialState: { ...listingInitialState },
  name: 'listing',
  reducers: {
    resetSearchStatus(state) {
      state.searchStatus = 'initial';
    },
    updateJsonQuery(state, action: PayloadAction<TJsonQuery>) {
      state.jsonQuery = action.payload;
    },
    updateMeta(state, action: PayloadAction<ISearchMeta>) {
      state.meta = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(applyFilters.fulfilled, (state, action) => {
      state.searchStatus = 'succeed';
      state.jsonQuery = action.payload.jsonQuery;
      state.meta = action.payload.meta;
    });
  },
});

export const { reducer: listingReducer, actions: listingActions } = listingSlice;
